export default {
  googleAuthorizeTerms: "Cette application ne sera plus prise en charge après le 10 mars 2023. Veuillez installer notre nouvelle version de {googleAppName}."
};

// @key: @#@"googleAuthorizeTerms"@#@ @source: @#@"This app will not be supported after Mar 10th, 2023. Please install our new version of {googleAppName}."@#@
